import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './ReviewsSubTabNavigation.module.css';

/**
 * ReviewsSubTabNavigation component provides navigation between received and given reviews
 */
const ReviewsSubTabNavigation = ({
    activeSubTab,
    totalReviewsReceived,
    totalReviewsGiven,
    onSubTabChange,
}) => {
    return (
        <div className={css.reviewsTabs}>
            <button
                className={classNames(css.reviewTab, activeSubTab === 'received' ? css.active : '')}
                onClick={() => onSubTabChange('received')}
                type="button"
            >
                <i className="ri-star-smile-line" />
                <span className={css.desktopText}>
                    <FormattedMessage id="StoreProfilePage.reviews.reviews" defaultMessage="Reviews" />
                </span>
                <span>
                    <FormattedMessage
                        id="StoreProfilePage.reviews.received"
                        defaultMessage="Received"
                    />
                </span>
                <span className={css.reviewCount}>{totalReviewsReceived || 0}</span>
            </button>
            <button
                className={classNames(css.reviewTab, activeSubTab === 'given' ? css.active : '')}
                onClick={() => onSubTabChange('given')}
                type="button"
            >
                <i className="ri-message-line" />
                <span className={css.desktopText}>
                    <FormattedMessage id="StoreProfilePage.reviews.reviews" defaultMessage="Reviews" />
                </span>
                <span>
                    <FormattedMessage
                        id="StoreProfilePage.reviews.given"
                        defaultMessage="Given"
                    />
                </span>
                <span className={css.reviewCount}>{totalReviewsGiven || 0}</span>
            </button>
        </div>
    );
};

ReviewsSubTabNavigation.propTypes = {
    activeSubTab: PropTypes.string.isRequired,
    totalReviewsReceived: PropTypes.number,
    totalReviewsGiven: PropTypes.number,
    onSubTabChange: PropTypes.func.isRequired,
};

export default ReviewsSubTabNavigation;
